// import axios from '@/axios'
import mbxGeocoding from '@mapbox/mapbox-sdk/services/geocoding'
import config from '@/config'

const geocodingClient = mbxGeocoding({ accessToken: config.mapboxAccessToken })

// const find = (order) => {
//   const basePath = 'https://nominatim.openstreetmap.org/search?format=json&addressdetails=1'
//   let path = ''

//   // if (!order) throw 'You need to pass "order" argument'
//   if (!order) return Promise.resolve([])

//   path = `${basePath}&q=${order.postalCode}+${order.post}`
//   path += order.city ? `+${order.city}` : ''
//   path += order.street ? `+${order.street}` : ''

//   return axios.get(path).then(response => {
//     if (!response.data.length) {
//       path = `${basePath}&q=${order.postalCode}+${order.post}`
//       return axios.get(path).then(response => {
//         if (!response.data.length) {
//           path = `${basePath}&q=${order.post}`
//           return axios.get(path)
//         }
//         return response
//       })
//     }
//     return response
//   })
// }

const geocode = (query, country) => {
	const options = {
		query,
		limit: 5
	}
	if (country) options.countries = [country]

	return geocodingClient
		.forwardGeocode(options)
		.send()
		.then(response => {
			let locations = []
			const matches = response.body.features
			if (matches.length) {
				locations = matches.map(({ place_name, center }) => ({
					display_name: place_name,
					lat: String(center[1]),
					lon: String(center[0])
				}))
			}
			console.log('query, locations', query, locations)
			return locations
		})
}

const find = order => {
	let queryWithPostCode = ''
	let queryWithoutPostCode = ''

	if (!order) throw 'You need to pass "order" argument'
	if (!order) return []

	queryWithoutPostCode += order.city && order.city !== order.post ? `${order.city}` : ''
	queryWithoutPostCode += order.street ? `, ${order.street}` : ''
	queryWithoutPostCode += order.state ? `, ${order.state}` : ''

	queryWithPostCode = `${order.postalCode} ${order.post}, ` + queryWithoutPostCode

	const country = order.country ? order.country.toLowerCase() : null
	return geocode(queryWithPostCode, country).then(locations => {
		if (locations.length) return locations
		else return geocode(queryWithoutPostCode, country)
	})
}

export default {
	find,
	geocode
}
